<template>
<!-- 这个页面目前废弃 -->
  <div>
    <div>
      <headbar title="实时盯盘" index="1"></headbar>
    </div>
    <!-- 头部图表 -->
    <div class="head_number">
      <div class="number_item" v-for="(item, i) in headNumList" :key="i">
        <div class="item_name">{{item.name}}</div>
        <div class="item_value1" :class="item.type == 0 ? 'up' : 'down'">{{item.value1}}</div>
        <div class="item_value2" :class="item.type == 0 ? 'up' : 'down'">{{item.value2}}</div>
      </div>
    </div>
    <div id="container"></div>

    <div class="streamer_wapper">
      <div class="streamer_content">
        <div class="time">· 10:59:31</div>
        <div class="sreamer_item"><span style="margin-right: 4px">ST熊猫</span><span style="color: #BD4057">即将打开涨停</span></div>
        <div class="sreamer_item"><span style="margin-right: 4px">开开实业</span><span style="color: #BD4057">即将打开涨停</span></div>
      </div>
    </div>

    <div class="row_line"></div>
    <!-- 领涨板块 -->
    <div class="Led_plate">
      <div class="led_plate_head">
        <div class="head_title">领涨板块</div>
        <div class="more">全部模块<van-icon name="arrow" /></div>
      </div>
      <div class="led_plate_main">
        <div class="led_plate_left">
          <div class="left_top">
            <div class="title_text">
              地下管廊
            </div>
            <div class="title_number">
              +2.99%
            </div>
          </div>
          <div class="left_bottom"><span style="margin-right: 12px">新兴铸管</span><span style="color: #D24352">+10.08%</span></div>
          <div id="plate" class="plate"></div>
        </div>
        <div class="led_plate_right">
          <div>
            <div class="left_top">
              <div class="title_text">
                年报季报
              </div>
              <div class="title_number">
                +2.96%
              </div>
            </div>
            <div class="left_bottom"><span style="margin-right: 12px">开开实业</span><span style="color: #D24352">+9.98%</span></div>
          </div>
          <div>
            <div class="left_top">
              <div class="title_text">
                住房租贷
              </div>
              <div class="title_number">
                +2.95%
              </div>
            </div>	
            <div class="left_bottom"><span style="margin-right: 12px">泰禾集团</span><span style="color: #D24352">+10.04%</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row_line"></div>

    <div class="market_heat">
      <div class="led_plate_head">
        <div class="head_title">
          <div>市场热度</div>
          <div class="progress_bar">
            <div class="skills_bar" id="skills"></div>
          </div>
          <div class="hot_number">{{hotNumber}}%</div>
        </div>
        <div class="more">
          <div class="more_text"><span>涨</span><span style="color: #d24352; margin-left: 4px;">1698</span></div>
          <div class="more_text"><span>跌</span><span style="color: #54a696; margin-left: 4px;">2794</span></div>
          <div class="more_text"><span>平</span><span style="margin-left: 4px;">106</span></div>
        </div>
      </div>
      <div class="led_palte_main">
        <div class="palte_item">
          <div class="palte_item_title">
            <div class="item_title_text">涨跌停对比</div>
            <div class="item_title_text"><span style="font-size: 18px; color: #D24352">42</span>:<span style="font-size: 18px; color: #54A696;">6</span></div>
          </div>
          <div id="contrast"></div>
        </div>
        <div class="palte_item">
          <div class="palte_item_title">
            <div class="first_title">
              <div>炸板率</div><div>33家</div>
            </div>
            <div class="plate_number">44.00%</div>
            <div id="FriedPlate"></div>
          </div>
        </div>
        <div class="palte_item">
        <div class="palte_item_title">
          <div class="item_title_text">昨涨停今表现</div>
          <div class="plate_number" style="color: #d24352">1.44%</div>
          <div id="raisingLimit"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
import headbar from '../../components/headbar.vue'
import { Area, TinyArea, Line, TinyLine } from '@antv/g2plot';
export default {
  data(){
    return {
      headNumList: [
        { name: '上证指数', value1: '3596.93', value2: '10.85 +0.30%', type: 0 },
        { name: '深证成指', value1: '14403.65', value2: '25.86 -0.18%', type: 1 },
        { name: '创业板指', value1: '3100.17', value2: '-27.31 -0.87%', type: 1 }
      ],
      hotNumber: 41
    }
  },
  mounted(){
    this.initHeadChars()
    this.initProgressBar()
  },
  methods: {
    initHeadChars(){
      const data = [
        {
          "Date": "2010-01",
          "scales": 1998
        },
        {
          "Date": "2010-02",
          "scales": 1850
        },
        {
          "Date": "2010-03",
          "scales": 1720
        },
        {
          "Date": "2010-04",
          "scales": 1818
        },
        {
          "Date": "2010-05",
          "scales": 1920
        },
        {
          "Date": "2010-06",
          "scales": 1802
        },
        {
          "Date": "2010-07",
          "scales": 1945
        },
        {
          "Date": "2010-08",
          "scales": 1856
        },
        {
          "Date": "2010-09",
          "scales": 2107
        },
        {
          "Date": "2010-10",
          "scales": 2140
        },
        {
          "Date": "2010-11",
          "scales": 2311
        },
        {
          "Date": "2010-12",
          "scales": 1972
        },
        {
          "Date": "2011-01",
          "scales": 1760
        },
        {
          "Date": "2011-02",
          "scales": 1824
        },
        {
          "Date": "2011-03",
          "scales": 1801
        },
        {
          "Date": "2011-04",
          "scales": 2001
        },
        {
          "Date": "2011-05",
          "scales": 1640
        },
        {
          "Date": "2011-06",
          "scales": 1502
        },
        {
          "Date": "2011-07",
          "scales": 1621
        },
        {
          "Date": "2011-08",
          "scales": 1480
        },
        {
          "Date": "2011-09",
          "scales": 1549
        },
        {
          "Date": "2011-10",
          "scales": 1390
        },
        {
          "Date": "2011-11",
          "scales": 1325
        },
        {
          "Date": "2011-12",
          "scales": 1250
        },
        {
          "Date": "2012-01",
          "scales": 1394
        },
        {
          "Date": "2012-02",
          "scales": 1406
        },
        {
          "Date": "2012-03",
          "scales": 1578
        },
        {
          "Date": "2012-04",
          "scales": 1465
        },
        {
          "Date": "2012-05",
          "scales": 1689
        },
        {
          "Date": "2012-06",
          "scales": 1755
        },
        {
          "Date": "2012-07",
          "scales": 1495
        },
        {
          "Date": "2012-08",
          "scales": 1508
        },
        {
          "Date": "2012-09",
          "scales": 1433
        },
        {
          "Date": "2012-10",
          "scales": 1344
        },
        {
          "Date": "2012-11",
          "scales": 1201
        },
        {
          "Date": "2012-12",
          "scales": 1065
        },
        {
          "Date": "2013-01",
          "scales": 1255
        },
        {
          "Date": "2013-02",
          "scales": 1429
        },
        {
          "Date": "2013-03",
          "scales": 1398
        },
        {
          "Date": "2013-04",
          "scales": 1678
        },
        {
          "Date": "2013-05",
          "scales": 1524
        },
        {
          "Date": "2013-06",
          "scales": 1688
        },
        {
          "Date": "2013-07",
          "scales": 1500
        },
        {
          "Date": "2013-08",
          "scales": 1670
        },
        {
          "Date": "2013-09",
          "scales": 1734
        },
        {
          "Date": "2013-10",
          "scales": 1699
        },
        {
          "Date": "2013-11",
          "scales": 1508
        },
        {
          "Date": "2013-12",
          "scales": 1680
        },
        {
          "Date": "2014-01",
          "scales": 1750
        },
        {
          "Date": "2014-02",
          "scales": 1602
        },
        {
          "Date": "2014-03",
          "scales": 1834
        },
        {
          "Date": "2014-04",
          "scales": 1722
        },
        {
          "Date": "2014-05",
          "scales": 1430
        },
        {
          "Date": "2014-06",
          "scales": 1280
        },
        {
          "Date": "2014-07",
          "scales": 1367
        },
        {
          "Date": "2014-08",
          "scales": 1155
        },
        {
          "Date": "2014-09",
          "scales": 1289
        },
        {
          "Date": "2014-10",
          "scales": 1104
        },
        {
          "Date": "2014-11",
          "scales": 1246
        },
        {
          "Date": "2014-12",
          "scales": 1098
        },
        {
          "Date": "2015-01",
          "scales": 1189
        },
        {
          "Date": "2015-02",
          "scales": 1276
        },
        {
          "Date": "2015-03",
          "scales": 1033
        },
        {
          "Date": "2015-04",
          "scales": 956
        },
        {
          "Date": "2015-05",
          "scales": 845
        },
        {
          "Date": "2015-06",
          "scales": 1089
        },
        {
          "Date": "2015-07",
          "scales": 944
        },
        {
          "Date": "2015-08",
          "scales": 1043
        },
        {
          "Date": "2015-09",
          "scales": 893
        },
        {
          "Date": "2015-10",
          "scales": 840
        },
        {
          "Date": "2015-11",
          "scales": 934
        },
        {
          "Date": "2015-12",
          "scales": 810
        },
        {
          "Date": "2016-01",
          "scales": 782
        },
        {
          "Date": "2016-02",
          "scales": 1089
        },
        {
          "Date": "2016-03",
          "scales": 745
        },
        {
          "Date": "2016-04",
          "scales": 680
        },
        {
          "Date": "2016-05",
          "scales": 802
        },
        {
          "Date": "2016-06",
          "scales": 697
        },
        {
          "Date": "2016-07",
          "scales": 583
        },
        {
          "Date": "2016-08",
          "scales": 456
        },
        {
          "Date": "2016-09",
          "scales": 524
        },
        {
          "Date": "2016-10",
          "scales": 398
        },
        {
          "Date": "2016-11",
          "scales": 278
        },
        {
          "Date": "2016-12",
          "scales": 195
        },
        {
          "Date": "2017-01",
          "scales": 145
        },
        {
          "Date": "2017-02",
          "scales": 207
        }
      ]
      const headChart = new Area('container', {
        height: 150,
        data,
        xField: 'Date',
        yField: 'scales',
        xAxis: {
          range: [0, 1],
          tickCount: 5,
          label: null,
        },
        yAxis: {
          label: null,
          grid: null,
        },
        theme: 'dark',
        smooth: true,
        areaStyle: () => {
          return {
            fill: 'l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff',
          }
        },
      } )
      headChart.render()

      const data1 = [
        264,
        417,
        438,
        887,
        309,
        397,
        550,
        575,
        563,
        430,
        525,
        592,
        492,
        467,
        513,
        546,
        983,
        340,
        539,
        243,
        226,
        192,
      ];
      const tinyArea = new TinyArea('plate', {
        height: 80,
        autoFit: false,
        data: data1,
        smooth: true,
        areaStyle: {
          fill: '#d6e3fd',
        },
      });
      tinyArea.render();

      const data2 = [{
        "time": '2016-08-08 00:00:00',
        "value": 10,
        "type": '预期收益率'
      }, {
        "time": '2016-08-08 00:10:00',
        "value": 22,
        "type": '预期收益率'
      }, {
        "time": '2016-08-08 00:30:00',
        "value": 16,
        "type": '预期收益率'
      }, {
        "time": '2016-08-09 00:35:00',
        "value": 26,
        "type": '预期收益率'
      }, {
        "time": '2016-08-09 01:00:00',
        "value": 12,
        "type": '预期收益率'
      }, {
        "time": '2016-08-09 01:20:00',
        "value": 26,
        "type": '预期收益率'
      }, {
        "time": '2016-08-10 01:40:00',
        "value": 18,
        "type": '预期收益率'
      }, {
        "time": '2016-08-10 02:00:00',
        "value": 26,
        "type": '预期收益率'
      }, {
        "time": '2016-08-10 02:20:00',
        "value": 12,
        "type": '预期收益率'
      }, {
        "time": '2016-08-08 00:00:00',
        "value": 4,
        "type": '实际收益率'
      }, {
        "time": '2016-08-08 00:10:00',
        "value": 3,
        "type": '实际收益率'
      }, {
        "time": '2016-08-08 00:30:00',
        "value": 6,
        "type": '实际收益率'
      }, {
        "time": '2016-08-09 00:35:00',
        "value": -12,
        "type": '实际收益率'
      }, {
        "time": '2016-08-09 01:00:00',
        "value": 1,
        "type": '实际收益率'
      }, {
        "time": '2016-08-09 01:20:00',
        "value": 9,
        "type": '实际收益率'
      }, {
        "time": '2016-08-10 01:40:00',
        "value": 13,
        "type": '实际收益率'
      }, {
        "time": '2016-08-10 02:00:00',
        "value": -3,
        "type": '实际收益率'
      }, {
        "time": '2016-08-10 02:20:00',
        "value": 11,
        "type": '实际收益率'
      }];

      const line = new Line('contrast', {
        data: data2,
        height: 80,
        xField: 'time',
        yField: 'value',
        seriesField: 'type',
        xAxis: {
          type: 'time',
          label: null,
          line: null
        },
        yAxis: {
          label: null,
          grid: null
        },
        smooth: true,
        legend: false
      });

      line.render();

      const data3 = [
        264,
        417,
        438,
        887,
        309,
        397,
        550,
        575,
        563,
        430,
        525,
        592,
        492,
        467,
        513,
        546,
        983,
        340,
        539,
        243,
        226,
        192,
      ];

      const tinyLine = new TinyLine('FriedPlate', {
        height: 60,
        autoFit: false,
        data: data3,
        smooth: true,
        lineStyle: {
          stroke: '#D24352'
        }
      });
      tinyLine.render();

      const tinyLine2 = new TinyLine('raisingLimit', {
        height: 60,
        autoFit: false,
        data: data3,
        smooth: true,
        lineStyle: {
          stroke: '#E3BC92'
        }
      });
      tinyLine2.render();
    },
    initProgressBar(){
      let skills = document.getElementById("skills")
      skills.style.height = this.hotNumber + '%'
    }
  },
  components: {
    headbar
  }
}
</script>
<style lang="scss" scoped>
  .head_number{
    background-color: #141414;
    display: flex;
    justify-content: space-around;
    .number_item{
      text-align: center;
      padding-top: 8px;
      .item_name{
        color: white;
        margin-bottom: 4px;
      }
      .item_value1{
        color: #BD4057;
        font-weight: bold;
        font-size: 22px;
        margin-bottom: 4px;
      }
      .item_value2{
        color: #BD4057;
        font-size: 12px;
      }
      .up{
        color: #BD4057;
      }
      .down{
        color: #54A696;
      }
    }
  }
  .streamer_wapper{
    height: 100%;
    padding: 12px;
    .streamer_content{
      display: flex;
      align-items: center;
      .time{
        font-size: 12px;
        color: #d2d2d2;
        margin-right: 5px;
      }
      .sreamer_item{
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
  }
  .row_line{
    height: 10px;
    width: 100%;
    background-color: #F6F5F8;
  }
  .Led_plate{
    .led_plate_head{
      padding: 12px;
      padding-bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .head_title{
        font-size: 18px;
        font-weight: bold;
      }
      .more{
        font-size: 14px;
        color: #919191;
      }
    }
    .led_plate_main{
      padding: 12px;
      padding-bottom: 0;
      display: flex;
      justify-content: space-between;
      .led_plate_left{
        padding: 12px;
        .left_top{
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          .title_text{
            font-size: 16px;
            font-weight: bold;
          }
          .title_number{
            color: white;
            background-color: #D24352;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 6px;
            border-radius: 8px;
            font-size: 14px;
          }
        }
        .left_bottom{
          margin-bottom: 12px;
        }
        .plate{
          width: 160px;
          margin-left: -12px;
        }
      }
      .led_plate_right{
        padding: 12px;
        .left_top{
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          .title_text{
            font-size: 16px;
            font-weight: bold;
          }
          .title_number{
            color: white;
            background-color: #D24352;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 6px;
            border-radius: 8px;
            font-size: 14px;
          }
        }
        .left_bottom{
          margin-bottom: 24px;
        }
        .plate{
          width: 160px;
          margin-left: -12px;
        }
      }
    }
  }
  .market_heat{
    .led_plate_head{
      padding: 12px;
      display: flex;
      justify-content: space-between;
      .head_title{
        font-size: 18px;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .progress_bar{
          width: 12px;
          height: 30px;
          background-color: #DDDDDD;
          display: flex;
          flex-direction: column-reverse;
          border-radius: 8px;
          margin-left: 8px;
          .skills_bar{
            height: 41%;
            background-color: #54A696;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }
        .hot_number{
          color: #54A696;
          margin-left: 8px;
        }
      }
      .more{
        display: flex;
        align-items: center;
        .more_text{
          font-size: 14px;
          font-weight: bold;
          color: #b0b0b9;
          margin-left: 8px;
        }
      }
    }
    .led_palte_main{
      padding: 12px;
      display: flex;
      .palte_item{
        width: 120px;
        .item_title_text{
          font-size: 14px;
          font-weight: bold;
          color: #b0b0b9;
          margin-bottom: 8px;
          margin-left: 8px;
        }
        .palte_item_title{
          box-sizing: border-box;
          .first_title{
            width: 80%;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: #b0b0b9;
            font-weight: bold;
            margin-bottom: 8px;
            margin-left: 8px;
          }
          .plate_number{
            font-size: 16px;
            font-weight: bold;
            margin-left: 8px;
          }
        }
      }
    }
  }
</style>